import { apiDate, number, optional, optionalDate, string, uuid, zodLess } from '@kaiizen/zod-less';

export const ApiPropertySchema = zodLess({
  id: uuid,
  name: string,
  address: optional(string),
  heroImage: optional(string),
  cherreId: optional(string),
  latitude: optional(number),
  longitude: optional(number),
  beds: optional(number),
  baths: optional(number),
  sqft: optional(number),
  vintage: optional(number),
  acres: optional(number),
  createdAt: apiDate,
  updatedAt: apiDate,
  deletedAt: optionalDate,
  spaceCount: number,
  levelCount: number,
  itemCount: number,
  photoCount: number,
  messageCount: number,
  itemNoteCount: number,
}, {
  ref: 'property',
  description:
    `Kai Properties are actually a bit of a misnomer. They would better be call a 'walkthrough'. There can be any number of Kai Properties for a given actual FusionProperty.
  They represent the information gathered from a user during a walkthrough of a property.
  The FusionProperty is the actual property from the Fusion API - with one unique ID per physical property.
  `,
});
